<template>
  <v-card class="sign-form">
    <template v-if="!success">
      <v-card-title>{{  $t('claimforms.sign.title') }}</v-card-title>
      <v-card-subtitle> {{  $t('claimforms.sign.subtitle1') }} </v-card-subtitle>

      <v-card-text>
        <v-checkbox v-model="checked" :label="$t('claimforms.sign.checkbox')"></v-checkbox>
      </v-card-text>

      <v-card-actions v-if="loading">
        <v-progress-linear color="primary" indeterminate/>
      </v-card-actions>
      <v-card-actions v-else>
        <v-btn color="primary" text @click="onContinue" :disabled="!checked">
          <v-icon left>mdi-pencil-outline</v-icon>{{ $t('claimforms.sign.continue') }}
        </v-btn>
        <v-spacer/>
        <v-btn text @click="$emit('close');">
          <v-icon left>mdi-close</v-icon>{{ $t('claimforms.sign.cancel') }}
        </v-btn>
      </v-card-actions>
    </template>

    <v-container v-else class="pa-0">
      <v-row no-gutters align="center">
        <v-col cols="4" align-self="stretch" class="text-center success-col d-flex">
          <div class="ma-auto">
            <p class="ma-0">
              <v-icon size="64" color="white">mdi-check-circle-outline</v-icon>
            </p>
            <p class="ma-0 text-h5">{{ $t('claimforms.sign.success.tick') }}</p>
          </div>
        </v-col>

        <v-col cols="8">
          <h4 class="text-h4 ma-4">{{ $t('claimforms.sign.success.title') }}</h4>
          <v-card-text>
            {{ $t('claimforms.sign.success.text1') }}
            <router-link to="CurrentRigths">{{  $t('menu.currentRights') }}</router-link>
            {{ $t('claimforms.sign.success.text2') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="$emit('close')">{{ $t('claimforms.sign.success.close') }}</v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-container>

  </v-card>
</template>

<script>
export default {
  name: "SignForm",
  props: {
    item: Object,
  },
  data() {
    return {
      smsCode: '',
      errorMessages: [],
      success: false,
      loading: false,
      checked: false,
    }
  },
  computed: {
    codeButtonDisabled() {
      return String(this.smsCode).length !== 6;
    }
  },
  methods: {
    onContinue() {
      this.loading = true;
      this.$store.dispatch('app/signForm', {item: this.item, code: ''})
        .then((res) => {
          if (res.rows?.length) {
            this.success = true;
            this.loading = false;
            this.$emit('signed');
          } else {
            throw res;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$toast(this.$t('claimforms.sign.error'))
          this.loading = false;
        })

    },
  }
}
</script>

<style lang="scss">
.sign-form {
  .v-card__subtitle {
    padding-bottom: 0;
  }

  .sms-input {
    margin: 0;
    padding: 0;

    input {
      font-size: 48px;
      letter-spacing: 4px;
      max-height: none;
      padding: 0;
    }
  }

  .success-col {
    background-color: var(--v-success-base);
    color: white;
  }
}
</style>